module.exports = __webpack_public_path__ + "static/media/pasticceria_8.2a238bc7.jpg";